import { CaretDownOutlined } from '@ant-design/icons';
import { Select, Popover } from 'antd';
import Button from '@ui-library/button';
import React from 'react';
import { FixMe } from '@utils/types';
import { useConnectionState, IField } from '../../../visualDataMappingProvider';
import { ColumnView, TableSelect } from '../mappingView/mappingViewHelpers';
import classes from './select-field-mapping.module.scss';

const { Option } = Select;
interface SelectMappingContentProps {
  addNewField: boolean;
  changeVisible: (visible: boolean) => void;
  onSelect: (field: IField) => void;
  onChangeMapping?: (
    mapping: { original?: string; mapped?: string },
    cl?: FixMe,
    index?: number,
  ) => void;
}

const PopOverFieldMappingContent = ({
  onSelect,
  addNewField,
  changeVisible,
  onChangeMapping,
}: SelectMappingContentProps) => {
  const {
    mappingConfig,
    uniqueIdentifierConfig,
    fieldMap,
    destinationConfig,
    createField,
    fields,
  } = useConnectionState();
  const defaultInputField = { name: '', label: '' };
  const [inputField, setInputField] = React.useState<{ name: string; label: string }>(
    defaultInputField,
  );

  const showCreate = inputField.name && destinationConfig.object?.supportsCustomFields;
  const matchedField = fields.find(
    (field) =>
      field.name.toLowerCase() === inputField.name.toLowerCase() ||
      field.label.toLowerCase() === inputField.name.toLowerCase(),
  );
  const handleBlur = (event: FixMe) => {
    event.preventDefault();
  };
  const onDropdownVisibleChange = (open: boolean) => {
    changeVisible(open);
    setInputField(defaultInputField);
  };
  const createFieldButtonPress = (event: FixMe) => {
    event.preventDefault();
    event.stopPropagation();
    if (onChangeMapping) {
      onChangeMapping({ mapped: inputField.name }, () => {
        createField({ name: inputField.name, label: inputField.label, createdNow: true });
      });
    }
    setInputField(defaultInputField);
  };

  const onClickInDropdown = React.useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
  }, []);

  const addFieldInMappings = (val: FixMe) => {
    onSelect(fieldMap[val.value]);
    setInputField(defaultInputField);
    changeVisible(false);
  };
  const createCustomFieldButton = (
    <Button
      disabled={Boolean(matchedField)}
      className={classes.add_field_button}
      onMouseDown={createFieldButtonPress}
      name={`Create '${inputField.label}'`}
    />
  );
  const createCustomFieldButtonPopover = matchedField ? (
    <Popover
      title="The input field can't be created"
      content={`The field already exists with ${matchedField.label} (${matchedField.name}) as Label (Name)`}
      placement="left"
    >
      <span>{createCustomFieldButton}</span>
    </Popover>
  ) : (
    createCustomFieldButton
  );
  const fieldOptions = fields
    ?.filter(
      (field) =>
        !(
          mappingConfig.some((curr) => curr.mapped === (field.name || field.label)) ||
          uniqueIdentifierConfig?.mapped === (field.name || field.label)
        ),
    )
    .map((field: IField) => (
      <Option
        value={field.name}
        label={field.label}
        key={`single-select-opt-key-${field.name}-${field.label}`}
      >
        <ColumnView column={fieldMap[field.name]} />
      </Option>
    ));
  const dropdownMenu = (
    menu: React.ReactElement<FixMe, string | React.JSXElementConstructor<FixMe>>,
  ) => (
    <div className={classes.select_field_wrapper}>
      {menu}

      {showCreate && (
        <div
          onMouseDown={handleBlur}
          role="presentation"
          className={classes.create_custom_field_wrapper}
        >
          {createCustomFieldButtonPopover}
        </div>
      )}
    </div>
  );

  const onFieldNameSearch = (val: string) => {
    setInputField({ label: val, name: val });
  };

  const noFieldFoundContent = (
    <div className={classes.no_field_found}>
      {inputField.name ? `No available field matched '${inputField.name}'` : 'No available fields'}
    </div>
  );
  return addNewField ? (
    <TableSelect
      autoFocus
      placeholder="Search or add field"
      value={{ value: inputField.name, label: inputField.label }}
      open
      labelInValue
      optionFilterProp="label"
      optionLabelProp="label"
      filterOption={(input, option) =>
        option?.props?.value?.toLowerCase().includes(input.toLowerCase()) ||
        option?.props?.label?.toLowerCase().includes(input.toLowerCase())
      }
      onDropdownVisibleChange={onDropdownVisibleChange}
      dropdownRender={dropdownMenu}
      showSearch
      defaultValue={{ value: inputField.name, label: inputField.label }}
      suffixIcon={<CaretDownOutlined />}
      onSearch={onFieldNameSearch}
      onClick={onClickInDropdown}
      onSelect={addFieldInMappings}
      notFoundContent={noFieldFoundContent}
    >
      {fieldOptions}
    </TableSelect>
  ) : null;
};

export default PopOverFieldMappingContent;
